var _style, _circle, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAgixIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 281.1 281.1",
    style: {
      enableBackground: "new 0 0 281.1 281.1"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill-rule:evenodd;clip-rule:evenodd;fill:#801BA4;}\n\t.st1{fill:#FFFFFF;}\n")), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "st0",
    cx: 140.6,
    cy: 140.6,
    r: 140.6
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    id: "Path",
    className: "st1",
    d: "M131.8,47.9c-7.1,6.7-13.3,14.1-16.8,22.3c-3.5,7.9-4.4,16.7-2.7,25.2c1.4,8.1,5.4,15.6,11.3,21.2 c5.9,5.9,13.9,10.8,22.3,16c8.4,5.3,17.6,11,25.2,19.7c7.7,8.8,12.2,19.9,12.8,31.6c0.8,11.2-2,22.4-7.9,32 c-5.8,9.3-14.2,16.2-22.9,21.4c-1.1,0.7-2.6,0.4-3.4-0.7c-0.8-1.1-0.6-2.6,0.4-3.4c7.4-6.3,13.7-13.7,17.4-21.9 c3.7-8.1,4.8-17.1,3.2-25.9c-1.3-8.4-5.3-16.1-11.5-21.8c-6.1-5.9-14.1-10.5-22.6-15.5c-8.5-5.1-17.8-10.4-25.8-18.9 c-4.1-4.3-7.4-9.3-9.8-14.7c-2.3-5.4-3.7-11.2-4.1-17C96.3,86,99,74,105.2,64.7c6.1-8.8,14.2-16,23.8-20.8c1.1-0.6,2.5-0.3,3.2,0.8 C132.9,45.6,132.7,47,131.8,47.9z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_00000109022932814979524860000008437187068882068387_",
    className: "st1",
    d: "M152,43.8c6.7,3.2,12.7,7.5,17.8,12.9 c2.7,2.9,5.1,6.1,7.1,9.5c2.1,3.6,3.7,7.5,4.8,11.6c1.1,4.1,1.6,8.4,1.7,12.7c-0.1,4.2-1.1,24.8-12.4,34.7c-1.4,1-3.2,1.4-4.9,1.1 c-1.7-0.3-3.2-1.3-4.2-2.7c-1.4-2.2-1.5-4.9-0.3-7.2l0.1-0.3c3-5.7,15.6-28,1.2-52.7c-3.8-5.6-8.2-10.9-13.1-15.7l0,0 c-0.8-0.9-0.9-2.3-0.1-3.2C150.2,43.6,151.1,43.4,152,43.8L152,43.8z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_00000162324789749188133970000007998243934067328944_",
    className: "st1",
    d: "M129.2,237.4c-6.7-3.2-12.7-7.5-17.8-12.9 c-2.7-2.9-5.1-6.1-7.1-9.5c-2.1-3.6-3.7-7.5-4.8-11.6c-1.1-4.1-1.6-8.4-1.7-12.7c0.1-4.2,1.1-24.8,12.4-34.7c1.4-1,3.2-1.4,4.9-1.1 c1.7,0.3,3.2,1.3,4.2,2.7c1.4,2.2,1.5,4.9,0.3,7.2l-0.1,0.3c-3,5.7-15.6,28-1.2,52.7c3.8,5.6,8.2,10.9,13.1,15.7l0,0 c0.8,0.9,0.9,2.3,0.1,3.2C131,237.6,130.1,237.8,129.2,237.4L129.2,237.4z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAgixIcon);
export default __webpack_public_path__ + "static/media/agix_icon.4ee6b953865e208b89b014d65c15c21c.svg";
export { ForwardRef as ReactComponent };